export default {
  apiKey: "AIzaSyDI6pkFOHURm1h6k81OYUD-LQ9mEwiTMzI",
  authDomain: "podcast-festival.firebaseapp.com",
  databaseURL: "https://podcast-festival.firebaseio.com",
  projectId: "podcast-festival",
  storageBucket: "podcast-festival.appspot.com",
  messagingSenderId: "450025612405"
}